import { useMemo } from 'react'

import { useActiveOrgId } from '~/hooks/org'
import { useSmartAccount } from '~/hooks/useSmartAccounts'
import { BackendTransaction } from '~/types'

export const useHasAccessOverride = (transaction: BackendTransaction) => {
  const activeOrgId = useActiveOrgId()
  const { smartAccount } = useSmartAccount(transaction?.smartAccountAddress)

  const orgId = transaction.isPublicTransaction ? undefined : transaction.orgId

  return useMemo(() => {
    // no active org or they're signed into a different org
    const isExternalContext = !activeOrgId || activeOrgId !== orgId

    // the viewer does have a smart account and either has signers or eoa signers
    const hasSigners =
      (smartAccount?.signers?.length ?? 0) > 0 ||
      (smartAccount?.eoaSigners?.length ?? 0) > 0

    return isExternalContext && hasSigners ? true : undefined
  }, [
    activeOrgId,
    orgId,
    smartAccount?.signers?.length,
    smartAccount?.eoaSigners?.length,
  ])
}
